import styled from "styled-components";
import media from "constants/media";

export const Title = styled.h2`
    margin-bottom: 10px;

    font-size: 25px;
    font-family: var(--font-DINProCondensed);
    line-height: 30px;
    letter-spacing: 1px;
    text-align: center;
    text-transform: uppercase;

    ${media.mdUp`
        margin-bottom: 18px;

        font-size: 32px;
        line-height: 40px;
    `}
`;

export const Text = styled.p`
    margin-bottom: 15px;

    font-size: 14px;
    line-height: 20px;
    text-align: center;

    ${media.mdUp`
        margin-bottom: 25px;

        font-size: 16px;
        line-height: 25px;
    `}
`;
